:host {
  /**
  * @prop --text-color: The color of the text
  */
  --text-color: var(--black);
  /**
  * @prop --font-family: The select's font family
  */
  --font-family: "Source Sans Pro", sans-serif;
  /**
  * @prop --font-size: The item's font size
  */
  --font-size: 14px;
  /**
  * @prop --font-weight: The item's font weight
  */
  --font-weight: bold;
  /**
  * @prop --item-color: The color of the step item
  */
  --item-color: var(--lightGray);
  /**
  * @prop --line-color: The color of item's line
  */
  --line-color: var(--lightGray);
  /**
  * @prop --item-active-color: The color of the active item
  */
  --item-active-color: var(--black);
}
:host .item {
  width: 250px;
}
:host .li-item {
  position: relative;
  display: flex;
  flex-direction: column;
}
:host .li-item--active .round-tab {
  background-color: var(--item-active-color);
}
:host .li-item--active .horizontal-line {
  background-color: var(--item-active-color);
}
:host .horizontal-line {
  background-color: var(--line-color);
  width: 100%;
  height: 3px;
  position: absolute;
  z-index: 1;
  top: 28px;
}
:host .round-tab {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: var(--item-color);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
:host .round-tab:hover {
  cursor: pointer;
}
:host .text {
  color: var(--text-color);
  font-size: var(--font-size);
  font-family: var(--font-family);
  font-weight: var(--font-weight);
  letter-spacing: 0.38px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
:host .text:hover {
  cursor: pointer;
}
:host .item-icon {
  position: absolute;
  z-index: 2;
}